import { atom } from "recoil";

import { type SubmitLensState, defaultSubmitLensState } from "../models";

export const submitLensStateAtom = atom<SubmitLensState>({
    key: "submitLensState",
    default: defaultSubmitLensState,
});
